module.exports = __webpack_public_path__ + "media/images/sebastiao_saltitao-b46ca2735fe9c4f2d6c297a5b1715703.png";